<mat-toolbar class="flex-row app-toolbar" [style.background-color]="toolbarColor">
  <div class="toolbar-brand flex-row align-center">
    <img src="assets/toproomslogo.png" width="47" height="47">
    <a mat-button routerLink="/"><h1>{{ projectTitle }} Voter Portal</h1></a>
  </div>
  <div class="toolbar-main hide-sm flex-row align-center" *ngIf="auth.currentUser as user">
    <ng-container *ngIf="!user.disabled">
      <a mat-button routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="user.status <= Status.PENDING">Apply</a>
      <a mat-button routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="user.status > Status.PENDING && user.status < Status.REVIEWER">Home</a>
      <a mat-button routerLink="/nominate" routerLinkActive="active" *ngIf="user.status >= Status.NOMINATOR">Nominate Rooms</a>
      <a mat-button routerLink="/rank" routerLinkActive="active" *ngIf="user.status >= Status.VOTER">Rank Rooms</a>
      <a mat-button routerLink="/review-public-data" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER || (user.status >= Status.VOTER && (user.rankingsSubmitted?.includes(year) ||
        settings.isPastVotingDeadline()))">Review Public Data</a>
      <div *ngIf="user.status >= Status.REVIEWER || user.isOwner" class="admin-buttons flex-row hide-md">
        <a mat-button routerLink="/review-applicants" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER || user.isOwner">Review Applicants</a>
        <a mat-button routerLink="/review-rooms" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER">Review Rooms</a>
        <a mat-button routerLink="/validate" routerLinkActive="active" *ngIf="user.status >= Status.APPROVER">Validate Data</a>
        <a mat-button routerLink="/analyze" routerLinkActive="active" *ngIf="user.status >= Status.APPROVER">Analyze Data</a>
      </div>
      <div *ngIf="user.status >= Status.REVIEWER || user.isOwner" class="admin-buttons flex-row hide-gt-md">
        <a mat-button [matMenuTriggerFor]="adminMenu" [class.active]="isAdminSection()">
          Admin <mat-icon>arrow_drop_down</mat-icon>
        </a>
        <mat-menu #adminMenu="matMenu">
          <a mat-menu-item routerLink="/review-applicants" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER || user.isOwner">Review Applicants</a>
          <a mat-menu-item routerLink="/review-rooms" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER">Review Rooms</a>
          <mat-divider></mat-divider>
          <a mat-menu-item routerLink="/validate" routerLinkActive="active" *ngIf="user.status >= Status.APPROVER">Validate Data</a>
          <a mat-menu-item routerLink="/analyze" routerLinkActive="active" *ngIf="user.status >= Status.APPROVER">Analyze Data</a>
        </mat-menu>
      </div>
    </ng-container>
  </div>
  <div class="toolbar-end hide-sm flex-row align-center">
    <a mat-button routerLink="/faq" routerLinkActive="active">FAQ</a>
    <a mat-button routerLink="/contact" routerLinkActive="active">Contact Us</a>
    <a mat-button *ngIf="!auth.currentUser" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Login</a>
    <ng-container *ngIf="auth.currentUser as user">
      <a mat-button [matMenuTriggerFor]="userMenu" [class.active]="isUserSection()">
        {{ user.realName }}
        <mat-icon>arrow_drop_down</mat-icon>
      </a>
      <mat-menu #userMenu="matMenu">
        <ng-container *ngIf="user.status >= Status.VOTER && !user.disabled">
          <a mat-menu-item routerLink="/profile" routerLinkActive="active">Edit Profile</a>
          <a mat-menu-item routerLink="/history" routerLinkActive="active">See History</a>
          <mat-divider></mat-divider>
        </ng-container>
        <a mat-menu-item href="{{websiteUrl}}">TERPECA Website</a>
        <a mat-menu-item href="{{roomFinderUrl}}">Room Finder</a>
        <mat-divider></mat-divider>
        <a mat-menu-item (click)="auth.logout()">Logout</a>
      </mat-menu>
    </ng-container>
  </div>
  <div class="hide-gt-sm flex-row justify-end align-center flex-default">
    <a mat-button [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </a>
    <mat-menu #menu="matMenu" xPosition="before">
      <div *ngIf="!auth.currentUser">
        <a mat-menu-item routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Login</a>
      </div>
      <div *ngIf="auth.currentUser as user">
        <ng-container *ngIf="!user.disabled">
          <a mat-menu-item routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="user.status <= Status.PENDING">Apply</a>
          <a mat-menu-item routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="user.status > Status.PENDING">Home</a>
          <a mat-menu-item routerLink="/nominate" routerLinkActive="active" *ngIf="user.status >= Status.NOMINATOR">Nominate Rooms</a>
          <a mat-menu-item routerLink="/rank" routerLinkActive="active" *ngIf="user.status >= Status.VOTER">Rank Rooms</a>
          <a mat-menu-item routerLink="/review-public-data" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER || (user.status >= Status.VOTER && (user.rankingsSubmitted?.includes(year) ||
            settings.isPastVotingDeadline()))">Review Public Data</a>
          <a mat-menu-item routerLink="/profile" routerLinkActive="active" *ngIf="user.status >= Status.VOTER">Edit Profile</a>
          <a mat-menu-item routerLink="/history" routerLinkActive="active" *ngIf="user.status >= Status.VOTER">See History</a>
          <mat-divider></mat-divider>
          <a mat-menu-item routerLink="/review-applicants" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER || user.isOwner">Review Applicants</a>
          <a mat-menu-item routerLink="/review-rooms" routerLinkActive="active" *ngIf="user.status >= Status.REVIEWER">Review Rooms</a>
          <a mat-menu-item routerLink="/validate" routerLinkActive="active" *ngIf="user.status >= Status.APPROVER">Validate Data</a>
          <a mat-menu-item routerLink="/analyze" routerLinkActive="active" *ngIf="user.status >= Status.APPROVER">Analyze Data</a>
          <mat-divider></mat-divider>
        </ng-container>
        <a mat-menu-item href="{{websiteUrl}}">TERPECA Website</a>
        <a mat-menu-item href="{{roomFinderUrl}}">Room Finder</a>
        <mat-divider></mat-divider>
      </div>
      <a mat-menu-item routerLink="/faq" routerLinkActive="active">FAQ</a>
      <a mat-menu-item routerLink="/contact" routerLinkActive="active">Contact Us</a>
      <mat-divider></mat-divider>
      <div *ngIf="auth.currentUser as user">
        <a mat-menu-item (click)="auth.logout()">Logout</a>
      </div>
    </mat-menu>
  </div>
</mat-toolbar>
